// eslint-disable-next-line @nx/workspace/no-restricted-imports-clone
import {
  type ComponentStyleConfig,
  theme as originalTheme,
} from '@chakra-ui/theme';

export const Accordion: ComponentStyleConfig = {
  parts: ['button', 'panel', 'container'],
  baseStyle: {
    button: {
      color: 'grey.900',
      fontSize: 'lg',
      fontWeight: 'bold',
      lineHeight: '1.5rem',
      letterSpacing: 'tight',
      _hover: {
        color: 'blue.500',
        background: 'none',
        fill: 'blue.500',
      },
    },
    panel: {
      letterSpacing: 'less-tight',
    },
  },
  variants: {
    republic: {
      button: {
        ...originalTheme.components.Accordion?.baseStyle?.button,
        fontWeight: 'normal',
        color: 'inherit',
        lineHeight: 'base',
        letterSpacing: 'extraWide',
      },
      panel: {
        ...originalTheme.components.Accordion?.baseStyle?.panel,
        pt: '4',
        pb: '0',
        mt: '0',
      },
      container: {
        ...originalTheme.components.Accordion?.baseStyle?.container,
        border: 'none',
        p: 0,
      },
    },
  },
};
